import { DocumentData, FirestoreDataConverter, QueryDocumentSnapshot, SnapshotOptions } from 'firebase/firestore';
import { toSeasonWeekID } from 'helpers/IdHelpers';
import { CategoryStats } from 'types';

// #region CONVERTERS *******************************************************************
export const categoryStatsToDoc = (stats: CategoryStats): DocumentData => {
  return {
    id: stats.id,
    rankingCategory: stats.rankingCategory,
    seasonAdjustedRanking: stats.seasonAdjustedRanking,
    seasonRanking: stats.seasonRanking,
    weeklyRanking: stats.weeklyRanking,
    weeklyAdjustedRanking: stats.weeklyAdjustedRanking,
    week: stats.week,
    year: stats.year,
    seasonWeekID: stats.seasonWeekID,
  };
};

export const categoryStatsConverter: FirestoreDataConverter<CategoryStats> = {
  toFirestore(stats: CategoryStats): DocumentData {
    return categoryStatsToDoc(stats);
  },

  fromFirestore(docSnap: QueryDocumentSnapshot, options?: SnapshotOptions): CategoryStats {
    const stats = docSnap.data(options);

    return {
      id: stats.id,
      rankingCategory: stats.rankingCategory,
      seasonAdjustedRanking: stats.seasonAdjustedRanking,
      seasonRanking: stats.seasonRanking,
      weeklyRanking: stats.weeklyRanking,
      weeklyAdjustedRanking: stats.weeklyAdjustedRanking,
      week: stats.week,
      year: stats.year ?? '2024',
      seasonWeekID: stats.seasonWeekID ?? toSeasonWeekID(stats.year ?? '2024', stats.week),
    };
  },
};
// #endregion
